var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyeTatLower = function SvgEyeTatLower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 45,
    height: 33,
    viewBox: "0 0 1.16 0.84",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.13;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2315579646304"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.91.26C.95.25.83.17.78.15.48-.02.35.09.11.28c.24.2.47.2.8-.02zM.06.64C.08.64.13.59.15.57.18.56.19.56.21.54.22.53.22.56.23.57c.02.05.02.06.05.11 0 .01 0 .02.01.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.13.59c.04.03.11.03.14.04M.52.63c.01.05.04.15.09.15C.71.79.77.68.57.7.5.7.68.68.6.61.57.59.52.61.49.63M.92.43C.88.48.84.54.91.59c.07.04.16 0 .18-.05"
  })))));
};

export default SvgEyeTatLower;